import axios from "axios";

export interface IGetNetworkRaCountParams {
    filters?: any,
}

export const getNetworkRaCount = async (params: IGetNetworkRaCountParams): Promise<number> => {
    const response = await axios.post('/network/ra/count-export', params);
    return response.data;
};

export default getNetworkRaCount;